let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8HLnB"), load("cEt9b"), load("bKvoJ")]).then(() => parcelRequire('aFK6m'));